export enum CountryCode {
  ALL = 'ALL',
  USA = 'USA',
  CA = 'CA'
}
